<article class="text-center">
  <h2 class="text-danger">Oops, something went wrong!
  </h2>
  <p>
    Please contact administrator or try again.
  </p>
</article>